import { IPartTagTemplate } from "../../models/PartTagTemplate";
import classNames from "../../utils/classNames";

interface PartTagListProps {
  tags: IPartTagTemplate[];
  selectedId: string | undefined;
  onSelect: (id: string | undefined) => void;
}

export default function PartTagList({ tags, selectedId, onSelect }: PartTagListProps) {
  return (
    <div className="min-h-[25vh]">
      <button
        type="button"
        className={classNames("w-full text-left px-3 py-2 hover:bg-gray-100", selectedId === undefined ? "bg-blue-50" : "")}
        onClick={() => onSelect(undefined)}
      >
        + Create New Tag
      </button>

      {tags.map((tag) => (
        <button
          key={tag.id}
          type="button"
          className={classNames("w-full text-left px-3 py-2 hover:bg-gray-100 flex items-center justify-between", selectedId === tag.id ? "bg-blue-50" : "")}
          onClick={() => onSelect(tag.id)}
        >
          <span className="flex items-center gap-2">
            <span>{tag.name}</span>
            {tag.isDefault && (
              <span className="rounded bg-primary-50 px-1.5 py-0.5 text-[10px] font-medium text-primary-700 ring-1 ring-inset ring-primary-200">
                Default
              </span>
            )}
          </span>
          {!tag.isDefault && (
            <span className="text-xs text-gray-500">
              {tag.categoryIds.length} {tag.categoryIds.length === 1 ? "category" : "categories"}
            </span>
          )}
        </button>
      ))}
    </div>
  );
}
